export default "__VITE_ASSET__CiOeCoVH__"